module.exports = __webpack_public_path__ + "static/img/szafa_27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/szafa_27.svg
// module id = nCvP
// module chunks = 0